export default __webpack_public_path__ + "static/media/D1.bf160fdc.jpg";